import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from "rxjs/Observable";
import { CityService } from '../../services/city.service';

@Component({
  selector: "table",
  templateUrl: './table.component.html',
  styleUrls: ["./table.component.scss"]
})
export class TableComponent implements OnInit, AfterViewInit {
  @Input() model: any;
  @Input() selectedTab: number;

  array: Observable<any[]>;//Observable <Array<any>>;
  myDataSource: any;
  displayedColumns = ['Name','this.filteredCities','ResidentTotal','LocalBusinessTotal','SiteAccessibilityTotal'];
  
 
  
  public ngOnInit(): void {

  }
  public constructor(private cityService: CityService) {
  }
  public ngAfterViewInit(): void { }

  ngOnChanges(changes: any) {
    //debugger
            if (changes['model']) {
                if (changes.model.currentValue) {
                   //debugger
                    this.array=Observable.of(changes.model.currentValue);
                }
            }
        }

}


// WEBPACK FOOTER //
// ./src/app/component/table/table.component.ts